var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-input-group-prepend',[_c('b-button',{staticClass:"font-weight-bold",attrs:{"size":"sm","variant":"info"},on:{"click":_vm.addCategory}},[_c('font-awesome-icon',{attrs:{"icon":"plus"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }